import restApiDispatcher from "@/store/utils/api-dispatcher";
import { Roster } from "@/models";

const getRosterList = (context, params) =>
  restApiDispatcher(context, {
    resource: Roster,
    storeKey: "rosterList",
    loadingKey: "rosterListLoading",
    action: "index",
    params
  });

const getRosterListLimited = (context, params) =>
  restApiDispatcher(context, {
    resource: Roster,
    storeKey: "rosterListLimited",
    loadingKey: "rosterListLoading",
    action: "indexLimited",
    commitType: "index",
    params
  });

const getRoster = (context, params) =>
  restApiDispatcher(context, {
    resource: Roster,
    storeKey: "player",
    loadingKey: "playerLoading",
    action: "show",
    commitType: "wrappedShow2",
    params
  });

const deletePlayer = (context, params) =>
  restApiDispatcher(context, {
    resource: Roster,
    storeKey: "player",
    loadingKey: "playerLoading",
    action: "delete",
    message: "Roster successfully deleted.",
    params
  });

const createPlayer = (context, params) =>
  restApiDispatcher(context, {
    resource: Roster,
    storeKey: "player",
    loadingKey: "playerLoading",
    action: "create",
    commitType: "wrappedShow2",
    message: "Roster successfully created.",
    params
  });

const editPlayer = (context, params) =>
  restApiDispatcher(context, {
    resource: Roster,
    storeKey: "player",
    loadingKey: "playerLoading",
    action: "edit",
    commitType: "wrappedShow2",
    message: params.message || "Roster details updated successfully.",
    params
  });

const uploadImage = (context, params) =>
  restApiDispatcher(context, {
    resource: Roster,
    storeKey: "image",
    loadingKey: "imageLoading",
    action: "uploadImage",
    message: "Image Uploaded",
    params
  });

const removePlayerFromRoster = (context, id) =>
  context.commit("REMOVE_PLAYER_FROM_ROSTER", id);

const clearLimitedRosterData = (context, id) =>
  context.commit("CLEAR_LIMITED_ROSTER");

export default {
  getRosterList,
  deletePlayer,
  editPlayer,
  removePlayerFromRoster,
  getRoster,
  createPlayer,
  uploadImage,
  getRosterListLimited,
  clearLimitedRosterData
};
